import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Note } from '../../../../../../shared/modules/notes/notes.types';
import { PanelsInterfaceComponent, PanelsInterfaceComponentBase } from '../panels-interface.component';
import { AddOfferComponent } from 'app/modules/projects/details/offers/add-offer/add-offer.component';
import { Offer } from 'app/modules/projects/details/offers/offers.types';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Property } from 'app/modules/projects/projects.types';
import { ColumnDef } from 'tsui/lib/ts-table/ts-table.model';
import { FeatureFlag } from '@core/enums';
import { AccountState } from '@state/account/state';

@Component({
  selector: 'project-panel-portfolio-details',
  templateUrl: './portfolio-detail.component.html',
  styleUrls: ['./portfolio-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsPortfolioDetailComponent
  extends PanelsInterfaceComponentBase
  implements PanelsInterfaceComponent, OnInit
{
  notes: Note[];
  offers: Offer[];
  displayColumns: string[];
  propertiesDataSource: MatTableDataSource<any>;
  properties: Property[] = [];

  columnDefs: ColumnDef[] = [];
  newTable: boolean;

  constructor(
    private _matDialog: MatDialog,
    protected readonly _changeDetectorRef: ChangeDetectorRef,
  ) {
    super(_changeDetectorRef);
    this.propertiesDataSource = new MatTableDataSource();
    this.displayColumns = ['name', 'fin_sub', 'property_id', 'interior_sq_ft', 'site_sq_ft', 'cap_rate', 'annual_rent'];
  }

  ngOnInit() {
    this.checkTable();
    this.notes = this.project.notes;

    this.project.children.forEach((child) => {
      this.properties.push(child.properties[0]);
      this.properties[this.properties.length - 1].project_id = child.id;
      this.properties[this.properties.length - 1].pipeline_id = child.pipeline_id;
    });

    this.propertiesDataSource.data = this.properties;

    this.titleFieldDef = {
      name: 'portfolio_details.panel_name',
      label: this.panelDef.title,
      type: 'text',
    };

    if (this.newTable) {
      this.setColDefs();
    }
  }

  openAddOfferModal(): void {
    const dialogRef = this._matDialog.open(AddOfferComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  openEditOfferModel(offer): void {
    const dialogRef = this._matDialog.open(AddOfferComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { project: this.project, options: this.data.options, offer: offer },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  setColDefs(): void {
    this.columnDefs = [
      {
        label: 'Name',
        name: 'name',
        type: 'text',
        tsTableOptions: {
          headerName: 'Name',
          field: 'name',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Fin Sub',
        name: 'fin_sub',
        type: 'text',
        tsTableOptions: {
          headerName: 'Fin Sub',
          field: 'cf_fin_sub',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Property ID',
        name: 'property_id',
        type: 'text',
        tsTableOptions: {
          headerName: 'Property ID',
          field: 'cf_prt_id',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Interior Sq Ft',
        name: 'interior_sq_ft',
        type: 'text',
        tsTableOptions: {
          headerName: 'Int Sqft',
          field: 'cf_total_interior_sq_ft',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Site Sq Ft',
        name: 'site_sq_ft',
        type: 'text',
        tsTableOptions: {
          headerName: 'Site Sqft',
          field: 'cf_total_site_sq_ft',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Cap Rate',
        name: 'cap_rate',
        type: 'text',
        tsTableOptions: {
          headerName: 'Cap Rate',
          field: 'cap_rate',
          editable: false,
          flex: 1,
        },
      },
      {
        label: 'Annual Rent',
        name: 'annual_rent',
        type: 'text',
        tsTableOptions: {
          headerName: 'Rent',
          field: 'annual_rent',
          editable: false,
          flex: 1,
        },
      },
    ];
  }

  checkTable() {
    this.newTable = this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_TABLE));
  }
}
